import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { checkIfInputHasAnError } from 'apps/Onboarding/views/BlueBook/components/FiscalInfo/helpers'
import { Field, useField } from 'react-final-form'
import { FormError, Select } from '@conekta/ui-component-library'
import { getLabelAndplaceholder } from '../../helpers'
import { IDocumentsManualInfoSelect } from '../../../../interface'
import { useTranslation } from 'react-i18next'

export const DocumentsManualInfoSelect = ({
  errors,
  field,
  taxRegimesOptions,
  touched
}: IDocumentsManualInfoSelect): ReactElement => {
  const { t } = useTranslation()
  const { name } = field
  const { label, placeholder } = getLabelAndplaceholder(name, t)

  return (
    <div className='documents-manual-info-form-select'>
      <span>{label}</span>
      <Field name={name}>
        {({ input }): ReactElement => {
          return (
            <fieldset
              className={classNames('no-left-margin', {
                hasError: checkIfInputHasAnError(errors, name, touched)
              })}
            >
              <Select
                {...input}
                className='test'
                isSearchable={false}
                name={name}
                options={taxRegimesOptions}
                placeholder={placeholder}
              />
              <FormError {...{ useField }} name={name} />
            </fieldset>
          )
        }}
      </Field>
    </div>
  )
}
